import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  // Separate toasts by position
  const topCenterToasts = toasts.filter(t => t.className?.includes('top-center-toast'));
  const bottomRightToasts = toasts.filter(t => !t.className?.includes('top-center-toast'));

  return (
    <ToastProvider>
      {/* Top center toasts (for validation errors) */}
      {topCenterToasts.map(function ({ id, title, description, action, className, ...props }) {
        return (
          <Toast key={id} className={`animate-slide-in-from-top ${className || ''}`} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle className="text-sm">{title}</ToastTitle>}
              {description && (
                <ToastDescription className="text-xs">{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport position="top-center" />
      
      {/* Bottom right toasts (default) */}
      {bottomRightToasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport position="bottom-right" />
    </ToastProvider>
  );
}
